import { TFunction } from 'i18next'
import z from 'zod'

import { AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS } from '../constants/automaticPaymentRemindersMaxDays'
import { AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS } from '../constants/automaticPaymentRemindersMinDays'

export const getNDaysSchema = (t: TFunction) => {
  return z
    .number()
    .int()
    .positive()
    .min(AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS, {
      message: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.form.error.select_days_min',
        { min: AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS },
      ),
    })
    .max(AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS, {
      message: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.form.error.select_days_max',
        { max: AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS },
      ),
    })
}
